<template>
  <div :class="[{ 'chat--hidden': !showMessage }, 'chat']">
    <i class="ion ion-close chat__close" @click="closeChat" />
    <el-tooltip
      :disabled="showMessage"
      content="Click to get help!"
      placement="top"
    >
      <div class="chat__image" @click="toggleChat" />
    </el-tooltip>
    <div class="chat__message">
      <slot />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      showMessage: (state) => state.common.isChatOpen,
    }),
  },
  methods: {
    toggleChat() {
      this.showMessage
        ? this.$store.commit('common/HIDE_CHAT_MESSAGE')
        : this.$store.commit('common/SHOW_CHAT_MESSAGE')
    },
    closeChat() {
      this.$store.commit('common/HIDE_CHAT_MESSAGE')
    },
  },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

.chat {
  z-index: 2;
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 255px;
  height: 100px;
  cursor: pointer;

  &:hover {
    .chat__close {
      display: initial;
    }
  }
}

.chat--hidden {
  &:hover {
    .chat__close {
      display: none;
    }
  }

  .chat__message {
    display: none;
  }
}

.chat__close {
  z-index: 2;
  display: none;
  font-size: 14px;
  color: $grey60;
  bottom: 165px;
  right: 20px;
  position: fixed;
}

.chat__image {
  z-index: 2;
  width: 48px;
  height: 48px;
  background-image: url('/static/img/magdalenabalcerzak.jpg');
  background-size: contain;
  position: fixed;
  right: 86px;
  bottom: 25px;
  border-radius: 50%;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
}

.chat__message {
  z-index: 2;
  bottom: 80px;
  right: 20px;
  position: fixed;
  background-color: $white;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 10px;
  border-radius: 6px;
  border: 0px;
  max-width: 255px;
  margin-bottom: 10px;
  padding: 14px;
  overflow-wrap: break-word;
  font-size: 14px;
}
</style>
